/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationValueSidebarMenuAliases {
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  BREADCRUMB = 'breadcrumb',
  DECK_MENU = 'deck-menu',
  FETCH_MENU = 'fetch-menu',
  FETCH_MENU_MOBILE = 'fetch-menu-mobile',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_MATERIALS = 'fragment-materials',
  FRAGMENT_PACKAGES = 'fragment-packages',
  FRAGMENT_PROCECURES = 'fragment-procecures',
  FRAGMENT_SERVICES = 'fragment-services',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_ACCREDITATION = 'layout-accreditation',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_ACCREDITATION = 'panel-accreditation',
  PANEL_MATERIALS = 'panel-materials',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_PACKAGES = 'panel-packages',
  PANEL_PROCEDURES = 'panel-procedures',
  PANEL_PROPOSAL = 'panel-proposal',
  PANEL_SERVICES = 'panel-services',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
  TEXT_MENU = 'text-menu',
}
export { NegotiationValueSidebarMenuAliases };
